/**
 * @module globalEventBus
 * @since 2.13.0
 */

import { glob } from '../../environment';
import { EventBus } from '../EventBus';

const KEY = Symbol.for('globalEventBus');

/**
 * A global instance of `EventBus`, useful when you need to "communicate" between several different consumers.
 * @type {EventBus}
 */
export const globalEventBus = glob[KEY] = glob[KEY] || new EventBus();
